import { Info } from "lucide-react";

import { usePanel } from "@/contexts/PanelContext";

import { SidebarBase } from "../SidebarBase";
import { InfoButtons } from "./InfoButtons";
import { InfoText } from "./InfoText";

/**
 * Information sidebar
 *
 * TODO: add customization for this post-event (#46)
 *
 * @returns
 */
export const InfoSidebar = () => {
  const { state, dispatch } = usePanel();

  return (
    <SidebarBase
      shown={Boolean(state.info)}
      setSidebarShown={() => dispatch(["info", undefined])}
      icon={Info}
      title="Info"
      description="Information about the event"
      side="Left"
    >
      <div className="flex flex-col h-full justify-between">
        <div>
          <InfoButtons />
          <InfoText />
        </div>
        <div className="p-2">
          <p className="text-xs text-default-600">Build {__COMMIT_HASH__}</p>
          <p className="text-xs text-default-600">
            &copy; 2023 - {__BUILD_YEAR__}{" "}
            <a
              href="https://sc07.com"
              target="_blank"
              rel="noreferrer"
              className="underline"
            >
              sc07
            </a>{" "}
            &{" "}
            <a
              href="https://sc07.dev/sc07/canvas"
              target="_blank"
              rel="noreferrer"
              className="underline"
            >
              contributors
            </a>
          </p>
        </div>
      </div>
    </SidebarBase>
  );
};
